import { useCallback, useEffect, useState } from "react";
import { DeviceMobile } from "@phosphor-icons/react";
import api, { fmtDate, logError } from "../lib/api";

export const LoginHistory = () => {
  const [data, setData] = useState(null);

  const load = useCallback(() => api.get("/auth/sessions")
    .then((r) => setData(r.data)).catch((e) => logError(e)), []);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;

  return (
    <div className="kcard p-5 space-y-3" data-testid="login-history-card">
      <div>
        <h3 className="font-display font-bold">Connexions</h3>
        <p className="text-xs text-gray-500">
          Un employé reste connecté sur un seul appareil, le patron sur deux. Une nouvelle connexion ferme la plus ancienne.
        </p>
      </div>
      <p className="text-xs font-semibold text-gray-600">Sessions actives : {data.active_sessions.length}</p>
      <div className="space-y-1.5 max-h-64 overflow-y-auto">
        {data.logins.map((l) => (
          <div key={l.id} data-testid="login-row" className="flex items-start gap-2 px-3 py-2 rounded-xl bg-[#F6F4EF]/60 text-xs">
            <DeviceMobile size={14} className="shrink-0 mt-0.5 text-[#3B6AA0]" />
            <div className="flex-1 min-w-0">
              <p className="font-semibold">{l.user_name} <span className="font-normal text-gray-500 capitalize">· {l.role}</span></p>
              <p className="text-gray-400 truncate">{l.device || "appareil inconnu"}</p>
            </div>
            <span className="text-gray-400 shrink-0">{fmtDate(l.created_at)}</span>
          </div>
        ))}
        {data.logins.length === 0 && <p className="text-xs text-gray-400">Aucune connexion enregistrée.</p>}
      </div>
    </div>
  );
};
